import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1 3C1 1.89543 1.89543 1 3 1H15C16.1046 1 17 1.89543 17 3V15C17 16.1046 16.1046 17 15 17H3C1.89543 17 1 16.1046 1 15V3Z"
      fill="#FFB743"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.5557 11.6666V7.22211H5.44455V11.6666H12.5557ZM5.44455 5.44434H12.5557C12.7914 5.44434 13.0175 5.53799 13.1842 5.70469C13.3509 5.87138 13.4446 6.09748 13.4446 6.33322V11.6666C13.4446 11.9023 13.3509 12.1284 13.1842 12.2951C13.0175 12.4618 12.7914 12.5554 12.5557 12.5554H5.44455C5.2088 12.5554 4.98271 12.4618 4.81601 12.2951C4.64931 12.1284 4.55566 11.9023 4.55566 11.6666V6.33322C4.55566 6.09748 4.64931 5.87138 4.81601 5.70469C4.98271 5.53799 5.2088 5.44434 5.44455 5.44434Z"
      fill="white"
    />
  </svg>
);
const SvgDemoTab = (props: IconProps) => (
  <SVGUniqueID>{Icon(props)}</SVGUniqueID>
);
export default SvgDemoTab;
